<script>
import constants from '@/constants';

export default {
    name: 'MaterialRequestStatusBadge',

    props: {
        status: {
            type: String,
            required: true,
        },
    },

    computed: {
        config() {
            return (
                constants.MATERIAL_REQUEST_STATUS_CONFIG[this.status] || {
                    text: this.status,
                    cssClass: '',
                    background: '#f3f4f6',
                    color: '#374151',
                    border: '#d1d5db',
                }
            );
        },

        badgeStyle() {
            return {
                backgroundColor: this.config.background,
                color: this.config.color,
                border: `1px solid ${this.config.border}`,
            };
        },
    },
};
</script>

<template>
    <span class="status_badge" :class="config.cssClass" :style="badgeStyle">
        {{ config.text }}
    </span>
</template>

<style scoped>
.status_badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}
</style>
